export default __webpack_public_path__ + "static/media/flexi_pay.33ca9bcb.png";